import { Info } from 'lucide-react';
import parse from 'parse-duration';
import toast from 'react-hot-toast';

const notify = {
  success: ({ title = 'Success', message, duration = '5s', ...rest }) =>
    toast.success(message || title, {
      duration: parse(duration),
      style: {
        border: '1px solid #7FD1B9',
        padding: '16px',
        background: '#F2FAF8',
        color: '#4c7d6f',
      },
      iconTheme: {
        primary: '#7FD1B9',
        secondary: '#F2FAF8',
      },
      iconStyle: {
        marginRight: '12px',
      },
      ...rest,
    }),

  error: ({ title = 'Error', message, duration = '5s', ...rest }) =>
    toast.error(message || title, {
      duration: parse(duration),
      style: {
        border: '1px solid #f2a9bb',
        padding: '16px',
        background: '#fff6f9',
        color: '#9a0736',
      },
      iconTheme: {
        primary: '#c31f48',
        secondary: '#fff6f9',
      },
      iconStyle: {
        marginRight: '12px',
      },
      ...rest,
    }),

  info: ({ title = 'Info', message, duration = '5s', ...rest }) =>
    toast(message || title, {
      icon: <Info />,
      duration: parse(duration),
      style: {
        border: '1px solid #62bab9',
        padding: '16px',
        background: '#e6fbfb',
        color: '#1c7c7b',
      },
      iconTheme: {
        primary: '#62bab9',
        secondary: '#e6fbfb',
      },
      iconStyle: {
        marginRight: '12px',
      },
      ...rest,
    }),

  loading: ({ title = 'Loading', message, duration = '5s', ...rest }) =>
    toast.loading(message || title, {
      duration: parse(duration),
      style: {
        border: '1px solid #63bae3',
        padding: '16px',
        background: '#ecf8fd',
        color: '#0b4f6c',
      },
      iconTheme: {
        primary: '#63bae3',
        secondary: '#ecf8fd',
      },
      iconStyle: {
        marginRight: '12px',
      },
      ...rest,
    }),

  // If you ever want full control:
  custom: (options) => toast(options),
};

export default notify;
